/*
    rxConnect® ePrescribing Middleware by HITORI.
    © 2025 HITORI (Melbourne, Australia). All rights reserved.
    Website: https://hitori-inc.com

    This software is proprietary and confidential.
    Unauthorised copying, distribution, or modification of this file, via any medium, is strictly prohibited.

    Styling and theming by licensed third parties is permitted under applicable agreements.
*/

import React, { useState, useEffect } from "react";
import apiService from "./apiService";
import DataTable from "./DataTable";

const App = () => {
      const [token, setToken] = useState(null);
      const [patientGUID, setPatientGUID] = useState(null);

      useEffect(() => {
            const queryParams = new URLSearchParams(window.location.search);
            const patientGUID = queryParams.get("t");

            if (patientGUID) {
                  setPatientGUID(patientGUID);
                  setToken(patientGUID);
            } else {
                  console.error("Missing security parameters required.");
            }
      }, []);

      if (!patientGUID) {
            return <div>Error: Missing required attributes in iframe.</div>;
      }

      if (!token) {
            return <div>Loading token...</div>;
      }

      return (
            <div>
                  <h1>rxConnect® Prescription Data</h1>
                  <DataTable patientGUID={patientGUID} token={token} apiService={apiService} />
            </div>
      );
};

export default App;
